import React from 'react';

import Currency from '../Currency';

import { getSystemSettings, getSessionId } from '../../utils/SettingsRetriever';
import { getDepositSchedule as globalGetDepositSchedule } from '../../services/cart';

import './index.scss';

// deposit_schedule: due_now, full

export default class TotalDueNow extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            due: [],
            loading: true,
            schedule_mode: false,
            applyBorder: props.applyBorder
        }

        if(getSystemSettings().app.deposit_schedule){
            this.state.schedule_mode = getSystemSettings().app.deposit_schedule;
        }
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps){
        if(prevProps.base !== this.props.base){
            this.init();
        }
    }

    init = () => {
        if (getSessionId() !== false){
            globalGetDepositSchedule({})
            .then( (result) => {
                // if(result.status === 200 && result.data.length > 0){
                let returnValue = [];
    
                if(result.length){
                    if (this.state.schedule_mode === 'due_now'){
                        result.forEach((item, idx) =>{
                            if (item.DueNow === 1){
                                returnValue = (
                                    <div className={"wrapDeposit" + (this.state.applyBorder ? ' border' : '')} key={idx}>
                                        <div className="label">
                                            Total due now:
                                        </div>
                                        <div className="dueprice">
                                            <Currency currency='usd' float={true} value={item.AmountDue}/>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    } else {
                        result.forEach((item, idx) => {
                            if (item.DueNow === 1){
                                returnValue.push(
                                    <div className={"wrapDeposit" + (this.state.applyBorder ? ' border' : '')} key={idx}>
                                        <div className="label">
                                            Total due now:
                                        </div>
                                        <div className="dueprice">
                                            <Currency float={true} currency='usd' value={item.AmountDue}/>
                                        </div>
                                    </div>
                                )
                            } else {
                                returnValue.push(
                                    <div className={"wrapDeposit" + (this.state.applyBorder ? ' border' : '')} key={idx}>
                                        <div className="label">
                                        Due on {item.DateDue}:
                                        </div>
                                        <div className="dueprice">
                                            <Currency float={true} currency='usd' value={item.AmountDue}/>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                }
                this.setState({...this.state, loading: false, due: returnValue});
            })
        }
        
    }

    render(){
        if(this.state.loading || !getSessionId()) return null;

        return (
            <div className="totalDueNow">
                {this.state.due}
            </div>
        )
    }
}